import { render, staticRenderFns } from "./OpenEventDialog.vue?vue&type=template&id=2d7d692d&"
import script from "./OpenEventDialog.vue?vue&type=script&lang=js&"
export * from "./OpenEventDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports